import React, { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';
import './JumpModeAnimation.css';

/**
 * 跳號模式全螢幕動畫組件
 *
 * 使用 React Portal 將動畫渲染到 body，避免被 Grid 容器限制
 * 簡化版：直接顯示在全螢幕，然後淡出
 */
export default function JumpModeAnimation({
  slotNumber,
  isComplete = false,
  onAnimationEnd
}) {
  const [animationState, setAnimationState] = useState('show'); // show -> fade-out -> done

  useEffect(() => {
    if (!slotNumber) return;

    // 1. 直接顯示在全螢幕
    setAnimationState('show');

    // 2. 1秒後開始淡出
    const fadeTimer = setTimeout(() => {
      setAnimationState('fade-out');
    }, 1000);

    // 3. 淡出完成，清理
    const doneTimer = setTimeout(() => {
      setAnimationState('done');
      onAnimationEnd?.();
    }, 1500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [slotNumber, onAnimationEnd]);

  if (!slotNumber || animationState === 'done') {
    return null;
  }

  // 使用 Portal 渲染到 body
  return createPortal(
    <div className={`jump-mode-overlay ${animationState}`}>
      <div className={`jump-mode-cell ${isComplete ? 'complete' : ''}`}>
        <div className="jump-mode-number">
          {slotNumber}
        </div>
      </div>
    </div>,
    document.body
  );
}
